"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableTable = void 0;
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var __1 = require("../");
var DateUtil_1 = require("../../utils/DateUtil");
var EditableColumn_1 = require("./EditableColumn");
var EditableHeadColumn_1 = require("./EditableHeadColumn");
var EditableRow_1 = require("./EditableRow");
var EditableRows_1 = require("./EditableRows");
var NonEditableRows_1 = require("./NonEditableRows");
var SharedComponents_1 = require("./SharedComponents");
var SharedFunctions_1 = require("./SharedFunctions");
var EditableTable = /** @class */ (function (_super) {
    __extends(EditableTable, _super);
    function EditableTable(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, columns = _a.columns, data = _a.data, editMode = _a.editMode, emptyRow = _a.emptyRow;
        var initData = {};
        columns.forEach(function (column) {
            initData[column.columnKey] = '';
        });
        _this.state = {
            editMode: editMode,
            emptyRow: emptyRow,
            data: data ? lodash_1.default.cloneDeep(data) : [],
            initData: initData,
            duplicatedExistingUniqueIds: [],
            duplicatedUniqueIds: [],
            deletedUniqueIds: [],
            invalidUniqueIds: [],
            duplicatedNewRecords: [],
            replaceAllButton: false,
            replacedUniqueIds: [],
            missingDataUniqueIds: [],
            validatingUniqueIds: [],
            hasValidationErrors: false,
        };
        _this.deleteAllIconClick = _this.deleteAllIconClick.bind(_this);
        _this.deleteIconClick = _this.deleteIconClick.bind(_this);
        _this.onAppend = _this.onAppend.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onValidate = _this.onValidate.bind(_this);
        _this.getError = _this.getError.bind(_this);
        _this.getFormatText = _this.getFormatText.bind(_this);
        _this.onUpdate = _this.onUpdate.bind(_this);
        _this.onPaste = _this.onPaste.bind(_this);
        _this.onSave = _this.onSave.bind(_this);
        _this.onSearch = _this.onSearch.bind(_this);
        _this.onDelete = _this.onDelete.bind(_this);
        _this.onReplace = _this.onReplace.bind(_this);
        _this.onUndoReplace = _this.onUndoReplace.bind(_this);
        _this.onReplaceAll = _this.onReplaceAll.bind(_this);
        _this.onProcessNewDuplicated = _this.onProcessNewDuplicated.bind(_this);
        return _this;
    }
    EditableTable.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var duplicatedNewRecords = this.state.duplicatedNewRecords;
        if (duplicatedNewRecords && duplicatedNewRecords.length > 0) {
            if (nextProps.duplicatedRecords !== this.props.duplicatedRecords) {
                this.onProcessNewDuplicated(nextProps.duplicatedRecords || []);
            }
        }
        else {
            this.setState({ editMode: nextProps.editMode });
            if (!nextProps.editMode) {
                this.setState({
                    deletedUniqueIds: [],
                    duplicatedUniqueIds: [],
                    duplicatedExistingUniqueIds: [],
                    duplicatedNewRecords: [],
                    invalidUniqueIds: [],
                    missingDataUniqueIds: [],
                    replacedUniqueIds: [],
                });
            }
            if (!lodash_1.default.isEqual(nextProps.data, this.props.data)) {
                this.setState({ data: nextProps.data });
            }
        }
    };
    EditableTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, buttons = _a.buttons, columns = _a.columns, defaultCode = _a.defaultCode, deleteAllIcon = _a.deleteAllIcon, deleteColumn = _a.deleteColumn, duplicateFields = _a.duplicateFields, enableHtmlEditor = _a.enableHtmlEditor, existingEditable = _a.existingEditable, htmlEditorMode = _a.htmlEditorMode, isDefault = _a.isDefault, requireFields = _a.requireFields, typeAheadDisplayRenderer = _a.typeAheadDisplayRenderer, typeAheadOptions = _a.typeAheadOptions, toolbarConfiguration = _a.toolbarConfiguration, responsive = _a.responsive, onError = _a.onError, rest = __rest(_a, ["buttons", "columns", "defaultCode", "deleteAllIcon", "deleteColumn", "duplicateFields", "enableHtmlEditor", "existingEditable", "htmlEditorMode", "isDefault", "requireFields", "typeAheadDisplayRenderer", "typeAheadOptions", "toolbarConfiguration", "responsive", "onError"]);
        var _b = this.state, data = _b.data, deletedUniqueIds = _b.deletedUniqueIds, duplicatedExistingUniqueIds = _b.duplicatedExistingUniqueIds, editMode = _b.editMode, emptyRow = _b.emptyRow, initData = _b.initData, replaceAllButton = _b.replaceAllButton;
        var existingRecords = lodash_1.default.filter(data, function (record) {
            return !record.isNew;
        });
        var newRecords = lodash_1.default.filter(data, { isNew: true });
        var className = this.props.className || '';
        if (responsive) {
            className += ' table-responsive';
        }
        return (React.createElement(SharedComponents_1.TableMargin, { className: className },
            React.createElement(SharedComponents_1.StyledTable, __assign({ responsive: responsive }, rest, { editMode: editMode }),
                React.createElement(SharedComponents_1.TableHead, null,
                    React.createElement(SharedComponents_1.TableRow, null,
                        columns.map(function (column, index) {
                            return (React.createElement(EditableHeadColumn_1.EditableHeadColumn, { key: "editable-head-column-".concat(index), editable: column.editable, editMode: editMode, minWidth: column.minWidth }, column.label));
                        }),
                        deleteColumn && (React.createElement(EditableHeadColumn_1.EditableHeadColumn, null, deleteAllIcon && (React.createElement(SharedComponents_1.DeleteAllIconContainer, { editMode: editMode, onClick: this.deleteAllIconClick },
                            React.createElement(__1.Icon, { name: 'delete' }))))))),
                React.createElement(SharedComponents_1.TableBody, null,
                    existingEditable ? (React.createElement(EditableRows_1.EditableRows, { editMode: editMode, isNewRow: false, data: existingRecords, columns: columns, deleteColumn: deleteColumn, deletedUniqueIds: deletedUniqueIds, duplicateFields: duplicateFields, duplicatedExistingUniqueIds: duplicatedExistingUniqueIds, enableHtmlEditor: enableHtmlEditor, existingEditable: existingEditable, htmlEditorMode: htmlEditorMode, requireFields: requireFields, toolbarConfiguration: toolbarConfiguration, typeAheadOptions: typeAheadOptions, typeAheadDisplayRenderer: typeAheadDisplayRenderer, onFormatText: this.getFormatText, onDelete: this.onDelete, onUpdate: this.onUpdate, onPaste: this.onPaste, onSelect: this.onSelect, deleteIconClick: this.deleteIconClick, getError: this.getError })) : (React.createElement(NonEditableRows_1.NonEditableRows, { editMode: editMode, isDefault: isDefault, defaultCode: defaultCode, isNewRow: false, data: existingRecords, columns: columns, deleteColumn: deleteColumn, deletedUniqueIds: deletedUniqueIds, duplicatedExistingUniqueIds: duplicatedExistingUniqueIds, onFormatText: this.getFormatText, deleteIconClick: this.deleteIconClick })),
                    newRecords && (React.createElement(EditableRows_1.EditableRows, { editMode: editMode, isNewRow: true, data: newRecords, columns: columns, deleteColumn: deleteColumn, deletedUniqueIds: deletedUniqueIds, duplicateFields: duplicateFields, duplicatedExistingUniqueIds: duplicatedExistingUniqueIds, enableHtmlEditor: enableHtmlEditor, existingEditable: existingEditable, htmlEditorMode: htmlEditorMode, requireFields: requireFields, toolbarConfiguration: toolbarConfiguration, typeAheadOptions: typeAheadOptions, typeAheadDisplayRenderer: typeAheadDisplayRenderer, onFormatText: this.getFormatText, onDelete: this.onDelete, onUpdate: this.onUpdate, onPaste: this.onPaste, onSelect: this.onSelect, deleteIconClick: this.deleteIconClick, getError: this.getError })),
                    editMode && emptyRow && (React.createElement(EditableRow_1.EditableRow, { requireFields: requireFields, duplicateFieldKeys: duplicateFields, record: initData, isEmptyRow: true, deleted: false, onAppend: this.onAppend, onChange: this.onChange, onValidate: this.onValidate, onPaste: function (column, clipboardData, event) { return _this.onPaste(-1, column, clipboardData, event); }, onSelect: function (columnKey, option, event) { return _this.onSelect(columnKey, option, true, event); }, onUpdate: this.onUpdate },
                        columns.map(function (column, columnIndex) {
                            return column.editable ? (React.createElement(EditableColumn_1.EditableColumn, { key: "editable-column-".concat(column.columnKey), column: column, enableHtmlEditor: enableHtmlEditor, isEmptyRow: true, editMode: editMode, htmlEditorMode: htmlEditorMode, record: initData, toolbarConfiguration: toolbarConfiguration, typeAheadOptions: typeAheadOptions, typeAheadDisplayRenderer: typeAheadDisplayRenderer, placeholder: column.placeholder, onSearch: _this.onSearch })) : (React.createElement(SharedComponents_1.TableColumn, { key: "editable-column-".concat(column.columnKey), editMode: editMode }, initData[column.columnKey]));
                        }),
                        deleteColumn && React.createElement(SharedComponents_1.TableColumn, { editMode: editMode }))))),
            editMode && buttons && (React.createElement(SharedComponents_1.Buttons, null,
                replaceAllButton && (React.createElement(SharedComponents_1.ReplaceAllButton, { size: 'sm', color: 'secondary', onClick: this.onReplaceAll, disabled: this.IsReplaceAllButtonDisabled() }, "Replace All")),
                React.createElement(SharedComponents_1.SaveButton, { size: 'sm', color: 'primary', onClick: this.onSave, disabled: !this.hasChanges() || this.state.hasValidationErrors }, "Save")))));
    };
    EditableTable.prototype.IsReplaceAllButtonDisabled = function () {
        var _a = this.props, columns = _a.columns, defaultCode = _a.defaultCode, isDefault = _a.isDefault;
        var _b = this.state, data = _b.data, duplicatedExistingUniqueIds = _b.duplicatedExistingUniqueIds;
        var filteredDuplicatedExistingUniqueIds = [];
        duplicatedExistingUniqueIds.forEach(function (uniqueId) {
            var record = lodash_1.default.find(data, function (o) {
                return o.uniqueId === uniqueId;
            });
            if (record) {
                var recordIsDefault = (0, SharedFunctions_1.IsDefault)(record, columns, isDefault, defaultCode);
                if (!recordIsDefault) {
                    filteredDuplicatedExistingUniqueIds.push(uniqueId);
                }
            }
        });
        return filteredDuplicatedExistingUniqueIds.length === 0;
    };
    EditableTable.prototype.hasChanges = function () {
        var _a = this.state, data = _a.data, deletedUniqueIds = _a.deletedUniqueIds;
        var newRecords = lodash_1.default.filter(data, { isNew: true });
        return newRecords.length > 0 || deletedUniqueIds.length > 0;
    };
    EditableTable.prototype.onSelect = function (columnKey, option, isEmptyRow, event) {
        if (option && option.code !== '' && option.text !== '') {
            this.onValidate(columnKey, {});
        }
    };
    // Process the clipboard data
    EditableTable.prototype.onPaste = function (recordIndex, column, clipboardData, event) {
        var _this = this;
        var _a = this.props, duplicateFields = _a.duplicateFields, existingEditable = _a.existingEditable, requireFields = _a.requireFields, onError = _a.onError, onPaste = _a.onPaste, onUpdate = _a.onUpdate;
        if (onPaste) {
            onPaste(event);
        }
        else {
            if (clipboardData) {
                var deletedUniqueIds_1 = this.state.deletedUniqueIds;
                var records_1 = (0, SharedFunctions_1.PasteData)(column.columnKey, clipboardData, requireFields);
                if (records_1 && records_1.length > 0) {
                    var multipleLinePaste = records_1.length > 1;
                    var data_1 = this.state.data;
                    var dataLength = data_1.length;
                    var newData = data_1;
                    if (recordIndex === -1) {
                        newData = __spreadArray(__spreadArray([], newData, true), records_1, true);
                    }
                    else if (multipleLinePaste) {
                        var existingDataCount = existingEditable
                            ? 0
                            : lodash_1.default.filter(data_1, function (o) {
                                return !o.isNew;
                            }).length;
                        for (var index = 0; index < records_1.length; index++) {
                            var record = records_1[index];
                            var i = index + recordIndex + existingDataCount;
                            if (i < dataLength) {
                                var existingRecord = newData[i];
                                existingRecord[column.columnKey] = record[column.columnKey];
                                newData.splice(i, 1, existingRecord);
                            }
                            else {
                                newData = __spreadArray(__spreadArray([], newData, true), [record], false);
                            }
                        }
                    }
                    var validatingUniqueIds = records_1.map(function (record) {
                        return record.uniqueId;
                    });
                    var duplicatedNewRecords_1 = [];
                    var newRecords_1 = lodash_1.default.filter(newData, { isNew: true });
                    // Check if there's any duplicated new rows(check against all new rows)
                    newRecords_1.forEach(function (record) {
                        if (duplicateFields) {
                            duplicateFields.forEach(function (field) {
                                var duplicatedRows = lodash_1.default.filter(newRecords_1, function (r) {
                                    return (record.uniqueId !== r.uniqueId &&
                                        duplicatedNewRecords_1.indexOf(record) === -1 &&
                                        record[field] &&
                                        record[field] !== '' &&
                                        record[field].toUpperCase() === r[field].toUpperCase());
                                });
                                if (duplicatedRows.length > 0) {
                                    duplicatedNewRecords_1.push(record);
                                }
                            });
                        }
                    });
                    this.setState({ data: newData, validatingUniqueIds: validatingUniqueIds, duplicatedNewRecords: duplicatedNewRecords_1 }, function () {
                        if (onUpdate) {
                            onUpdate(data_1, deletedUniqueIds_1);
                        }
                        if (duplicatedNewRecords_1.length === 0) {
                            _this.onProcessNewDuplicated(records_1);
                        }
                        else {
                            if (onError) {
                                onError(duplicatedNewRecords_1);
                            }
                        }
                    });
                    if (event && (multipleLinePaste || recordIndex === -1)) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                }
            }
        }
    };
    // Function to show error or yes icon in cell
    EditableTable.prototype.getError = function (column, record) {
        var _a = this.props, existingEditable = _a.existingEditable, validateExisting = _a.validateExisting;
        if (record.isNew || (existingEditable && validateExisting && !record.isNew)) {
            var _b = this.props, duplicateFields = _b.duplicateFields, invalidFields = _b.invalidFields, requireFields = _b.requireFields;
            var _c = this.state, duplicatedUniqueIds = _c.duplicatedUniqueIds, invalidUniqueIds = _c.invalidUniqueIds, missingDataUniqueIds = _c.missingDataUniqueIds, validatingUniqueIds = _c.validatingUniqueIds;
            // Check if record is being validated
            if (validatingUniqueIds) {
                if (validatingUniqueIds.indexOf(record.uniqueId) > -1) {
                    return {
                        validating: true,
                    };
                }
            }
            // Check if record key invalid
            if (invalidFields && invalidFields.indexOf(column.columnKey) > -1) {
                if (invalidUniqueIds.indexOf(record.uniqueId) > -1) {
                    return {
                        hasError: true,
                        errorType: 'invalid',
                        message: column.invalidMessage,
                    };
                }
            }
            // Check if record key duplicated
            if (duplicateFields && duplicateFields.indexOf(column.columnKey) > -1) {
                if (duplicatedUniqueIds.indexOf(record.uniqueId) > -1) {
                    return {
                        hasError: true,
                        errorType: 'duplicated',
                        message: column.duplicatedMessage,
                    };
                }
            }
            // Check the required fields
            if (missingDataUniqueIds && missingDataUniqueIds.indexOf(record.uniqueId) > -1) {
                if (requireFields && requireFields.indexOf(column.columnKey) > -1) {
                    if (!record[column.columnKey] || record[column.columnKey] === '') {
                        var requiredMessage_1 = column.requiredMessage;
                        if (requiredMessage_1) {
                            var regex = /[$]\S+/g;
                            var needToBeReplacedKeys = column.requiredMessage.match(regex);
                            if (needToBeReplacedKeys && needToBeReplacedKeys.length > 0) {
                                needToBeReplacedKeys.forEach(function (key) {
                                    var columnKey = key.replace('$', '');
                                    requiredMessage_1 = requiredMessage_1.replace(key, record[columnKey]);
                                });
                            }
                            return {
                                hasError: true,
                                errorType: 'required',
                                message: requiredMessage_1,
                            };
                        }
                    }
                }
            }
        }
        return {};
    };
    // Function to format the date column
    // Show the replace button if there're any duplicated new records to column(replaceButton=true)
    EditableTable.prototype.getFormatText = function (column, record) {
        var _this = this;
        if (record.isNew && column.replaceButton) {
            var _a = this.props, columns = _a.columns, defaultCode = _a.defaultCode, isDefault = _a.isDefault;
            var recordIsDefault = (0, SharedFunctions_1.IsDefault)(record, columns, isDefault, defaultCode);
            // Do not show replace button for row with default culture
            if (!recordIsDefault) {
                var _b = this.state, duplicatedUniqueIds = _b.duplicatedUniqueIds, invalidUniqueIds = _b.invalidUniqueIds, replacedUniqueIds = _b.replacedUniqueIds;
                if (invalidUniqueIds.indexOf(record.uniqueId) === -1) {
                    // Check if record is duplicated
                    if (duplicatedUniqueIds.indexOf(record.uniqueId) > -1) {
                        return (React.createElement(SharedComponents_1.ReplaceButton, { size: 'xs', onClick: function () { return _this.onReplace(record); } }, "Replace Existing"));
                    }
                    else if (replacedUniqueIds.indexOf(record.uniqueId) > -1) {
                        return (React.createElement(SharedComponents_1.ReplaceButton, { size: 'xs', onClick: function () { return _this.onUndoReplace(record); } }, "Undo Replace"));
                    }
                }
            }
        }
        if (column.dataType === 'date' && record[column.columnKey]) {
            var date = new Date(record[column.columnKey]);
            return DateUtil_1.DateUtil.formatDateToLocal(date, column.format);
        }
        return record[column.columnKey];
    };
    // Function to search type ahead options if remote search is enabled
    EditableTable.prototype.onSearch = function (columnKey, text, event) {
        var onSearch = this.props.onSearch;
        if (onSearch) {
            onSearch(columnKey, text, event);
        }
    };
    EditableTable.prototype.onProcessNewDuplicated = function (records) {
        var _this = this;
        if (records && records.length) {
            var _a = this.props, columns = _a.columns, typeAheadOptions_1 = _a.typeAheadOptions, onUpdate_1 = _a.onUpdate;
            var _b = this.state, data_2 = _b.data, deletedUniqueIds_2 = _b.deletedUniqueIds, validatingUniqueIds_1 = _b.validatingUniqueIds;
            records.forEach(function (record) {
                if (record.action === 'deleted') {
                    lodash_1.default.remove(data_2, { uniqueId: record.uniqueId });
                }
                lodash_1.default.remove(validatingUniqueIds_1, record.uniqueId);
            });
            var newRecords = lodash_1.default.filter(data_2, { isNew: true });
            var typeAheadColumn_1 = lodash_1.default.find(columns, function (column) {
                return column.updateRelatedColumn;
            });
            if (newRecords && newRecords.length > 0) {
                if (typeAheadColumn_1 && typeAheadColumn_1.updateRelatedColumn && typeAheadColumn_1.updateRelatedColumnKey) {
                    newRecords.forEach(function (record) {
                        var option = lodash_1.default.find(typeAheadOptions_1, function (o) {
                            return o.code.toUpperCase() === record[typeAheadColumn_1.columnKey].toUpperCase();
                        });
                        if (option) {
                            record[typeAheadColumn_1.columnKey] = option.code;
                            record[typeAheadColumn_1.updateRelatedColumnKey] = option[typeAheadColumn_1.updateRelatedColumnType || 'text'];
                        }
                    });
                }
            }
            this.setState({ data: data_2, duplicatedNewRecords: [], validatingUniqueIds: validatingUniqueIds_1 }, function () {
                _this.onValidate('', {});
                if (onUpdate_1) {
                    onUpdate_1(data_2, deletedUniqueIds_2);
                }
            });
        }
    };
    // Function to be called when save button clicked
    EditableTable.prototype.onSave = function (event) {
        var validateRequiredOnSave = this.props.validateRequiredOnSave;
        if (validateRequiredOnSave) {
            this.onValidate('', {}, true);
        }
        // Check if there's any error
        var _a = this.state, deletedUniqueIds = _a.deletedUniqueIds, duplicatedExistingUniqueIds = _a.duplicatedExistingUniqueIds, duplicatedUniqueIds = _a.duplicatedUniqueIds, invalidUniqueIds = _a.invalidUniqueIds, missingDataUniqueIds = _a.missingDataUniqueIds;
        if (duplicatedExistingUniqueIds.length > 0 ||
            duplicatedUniqueIds.length > 0 ||
            invalidUniqueIds.length > 0 ||
            missingDataUniqueIds.length > 0) {
            this.setState({ hasValidationErrors: true });
        }
        var onSave = this.props.onSave;
        if (onSave) {
            onSave(this.state.data, deletedUniqueIds, this.state.hasValidationErrors, event);
        }
    };
    // Function to replace the existing duplicated record with new record(individual)
    // Set the existing record status to deleted
    EditableTable.prototype.onReplace = function (record) {
        var _this = this;
        var duplicateFields = this.props.duplicateFields;
        var _a = this.state, data = _a.data, deletedUniqueIds = _a.deletedUniqueIds, replacedUniqueIds = _a.replacedUniqueIds;
        if (duplicateFields && duplicateFields.length > 0) {
            duplicateFields.forEach(function (columnKey) {
                var existingRecords = lodash_1.default.filter(data, function (o) {
                    return !o.isNew && o[columnKey] === record[columnKey];
                });
                if (existingRecords) {
                    existingRecords.forEach(function (o) {
                        deletedUniqueIds.push(o.uniqueId);
                    });
                    replacedUniqueIds.push(record.uniqueId);
                }
                _this.setState({ deletedUniqueIds: deletedUniqueIds }, function () {
                    _this.onValidate('', {});
                });
            });
        }
    };
    // Function to undo the replacement
    EditableTable.prototype.onUndoReplace = function (record) {
        var _this = this;
        var duplicateFields = this.props.duplicateFields;
        var _a = this.state, data = _a.data, deletedUniqueIds = _a.deletedUniqueIds, replacedUniqueIds = _a.replacedUniqueIds;
        if (duplicateFields && duplicateFields.length > 0) {
            duplicateFields.forEach(function (columnKey) {
                var existingDeletedRecords = lodash_1.default.filter(data, function (o) {
                    return o[columnKey] === record[columnKey] && !o.isNew;
                });
                existingDeletedRecords.forEach(function (existingRecord) {
                    lodash_1.default.remove(deletedUniqueIds, function (o) {
                        return o === existingRecord.uniqueId;
                    });
                });
                lodash_1.default.remove(replacedUniqueIds, function (o) {
                    return o === record.uniqueId;
                });
                _this.setState({ deletedUniqueIds: deletedUniqueIds, replacedUniqueIds: replacedUniqueIds }, function () {
                    _this.onValidate('', {});
                });
            });
        }
    };
    // Function to replace all the duplicated existing records with new records
    EditableTable.prototype.onReplaceAll = function () {
        var _this = this;
        var _a = this.props, columns = _a.columns, defaultCode = _a.defaultCode, isDefault = _a.isDefault;
        var _b = this.state, data = _b.data, deletedUniqueIds = _b.deletedUniqueIds, duplicatedUniqueIds = _b.duplicatedUniqueIds, duplicatedExistingUniqueIds = _b.duplicatedExistingUniqueIds, replacedUniqueIds = _b.replacedUniqueIds;
        var filteredDuplicatedExistingUniqueIds = [];
        duplicatedExistingUniqueIds.forEach(function (uniqueId) {
            var record = lodash_1.default.find(data, function (o) {
                return o.uniqueId === uniqueId;
            });
            if (record) {
                var recordIsDefault = (0, SharedFunctions_1.IsDefault)(record, columns, isDefault, defaultCode);
                if (!recordIsDefault) {
                    filteredDuplicatedExistingUniqueIds.push(uniqueId);
                }
            }
        });
        var newDeletedUniqueIds = __spreadArray(__spreadArray([], deletedUniqueIds, true), filteredDuplicatedExistingUniqueIds, true);
        var newDuplicatedExistingUniqueIds = lodash_1.default.filter(duplicatedExistingUniqueIds, function (uniqueId) {
            return filteredDuplicatedExistingUniqueIds.indexOf(uniqueId) === -1;
        });
        this.setState({
            deletedUniqueIds: newDeletedUniqueIds,
            duplicatedExistingUniqueIds: newDuplicatedExistingUniqueIds,
            replacedUniqueIds: __spreadArray(__spreadArray([], replacedUniqueIds, true), duplicatedUniqueIds, true),
        }, function () {
            _this.onValidate('', {});
        });
    };
    // Delete all records
    EditableTable.prototype.deleteAllIconClick = function (event) {
        var _this = this;
        var onUpdate = this.props.onUpdate;
        var _a = this.state, data = _a.data, editMode = _a.editMode;
        if (editMode) {
            var _b = this.props, columns_1 = _b.columns, defaultCode_1 = _b.defaultCode, isDefault_1 = _b.isDefault;
            // Delete all new data
            lodash_1.default.remove(data, { isNew: true });
            // Mark all existing data(exclude rows with default culture) as deleted
            var deletedUniqueIds_3 = [];
            data.forEach(function (record) {
                var recordIsDefault = (0, SharedFunctions_1.IsDefault)(record, columns_1, isDefault_1, defaultCode_1);
                if (!recordIsDefault) {
                    deletedUniqueIds_3.push(record.uniqueId);
                }
            });
            this.setState({ deletedUniqueIds: deletedUniqueIds_3 }, function () {
                _this.onValidate('', {});
                if (onUpdate) {
                    onUpdate(data, deletedUniqueIds_3);
                }
            });
        }
    };
    // Delete individual record(new or existing)
    EditableTable.prototype.deleteIconClick = function (record, deleted) {
        var _this = this;
        var _a = this.props, duplicateFields = _a.duplicateFields, onUpdate = _a.onUpdate;
        var _b = this.state, data = _b.data, editMode = _b.editMode, replacedUniqueIds = _b.replacedUniqueIds;
        if (editMode) {
            var deletedUniqueIds_4 = this.state.deletedUniqueIds;
            if (record.isNew) {
                // Delete new record
                lodash_1.default.remove(data, { uniqueId: record.uniqueId });
                lodash_1.default.remove(replacedUniqueIds, record.uniqueId);
                duplicateFields.forEach(function (field) {
                    var existingRecords = lodash_1.default.filter(data, function (o) {
                        return !o.isNew && o[field] === record[field];
                    });
                    if (existingRecords && existingRecords.length > 0) {
                        existingRecords.forEach(function (o) {
                            deletedUniqueIds_4 = lodash_1.default.pull(deletedUniqueIds_4, o.uniqueId);
                        });
                    }
                });
            }
            else {
                if (deleted) {
                    // Undo the deletion of the existing record
                    deletedUniqueIds_4 = lodash_1.default.pull(deletedUniqueIds_4, record.uniqueId);
                }
                else {
                    // Delete the existing record
                    deletedUniqueIds_4 = __spreadArray(__spreadArray([], this.state.deletedUniqueIds, true), [record.uniqueId], false);
                }
            }
            this.setState({ deletedUniqueIds: deletedUniqueIds_4, data: data }, function () {
                _this.onValidate('', {});
                if (onUpdate) {
                    onUpdate(data, deletedUniqueIds_4);
                }
            });
        }
    };
    // This function will be called whenever data changed
    /* To validate:
         duplicated new records
         duplicated existing records
         deleted records
         invalid records
    */
    EditableTable.prototype.onValidate = function (columnKey, record, isSave) {
        var _a = this.props, columns = _a.columns, duplicateFields = _a.duplicateFields, existingEditable = _a.existingEditable, invalidFields = _a.invalidFields, requireFields = _a.requireFields, typeAheadOptions = _a.typeAheadOptions, validateExisting = _a.validateExisting, validateRequiredOnSave = _a.validateRequiredOnSave, onError = _a.onError;
        var _b = this.state, data = _b.data, deletedUniqueIds = _b.deletedUniqueIds, replacedUniqueIds = _b.replacedUniqueIds, validatingUniqueIds = _b.validatingUniqueIds;
        // Need to process those duplicated new rows before validate
        if (this.state.duplicatedNewRecords && this.state.duplicatedNewRecords.length > 0) {
            return;
        }
        var records = [];
        if (existingEditable && validateExisting) {
            records = data;
        }
        else {
            records = lodash_1.default.filter(data, { isNew: true });
        }
        if (records) {
            var duplicatedUniqueIds_1 = [];
            var duplicatedExistingUniqueIds_1 = [];
            var invalidUniqueIds_1 = [];
            var duplicatedNewRecords_2 = [];
            var missingDataUniqueIds_1 = [];
            records.forEach(function (newRecord) {
                // Need to validate against all data
                // Need to validate if there's any duplicated new record
                data.forEach(function (r) {
                    if (duplicateFields) {
                        duplicateFields.forEach(function (field) {
                            if (r[field] === newRecord[field] && r.uniqueId !== newRecord.uniqueId && deletedUniqueIds.indexOf(r.uniqueId) === -1) {
                                duplicatedUniqueIds_1.push(newRecord.uniqueId);
                                if (!r.isNew) {
                                    duplicatedExistingUniqueIds_1.push(r.uniqueId);
                                }
                                if (r.isNew && duplicatedNewRecords_2.indexOf(newRecord) === -1 && newRecord[field] && newRecord[field] !== '') {
                                    duplicatedNewRecords_2.push(newRecord);
                                }
                            }
                        });
                    }
                });
                if (invalidFields) {
                    invalidFields.forEach(function (field) {
                        var column = lodash_1.default.find(columns, { columnKey: field });
                        if (column && typeAheadOptions) {
                            var option = lodash_1.default.find(typeAheadOptions, function (o) {
                                return o.code.toUpperCase() === newRecord[field].toUpperCase();
                            });
                            if (!option) {
                                invalidUniqueIds_1.push(newRecord.uniqueId);
                            }
                        }
                    });
                }
                if (requireFields && ((validateRequiredOnSave && validateRequiredOnSave === isSave) || !validateRequiredOnSave)) {
                    requireFields.forEach(function (field) {
                        if ((!newRecord[field] || newRecord[field] === '') && missingDataUniqueIds_1.indexOf(newRecord.uniqueId) === -1) {
                            missingDataUniqueIds_1.push(newRecord.uniqueId);
                        }
                    });
                }
            });
            this.setState({
                duplicatedUniqueIds: duplicatedUniqueIds_1,
                duplicatedExistingUniqueIds: duplicatedExistingUniqueIds_1,
                invalidUniqueIds: invalidUniqueIds_1,
                duplicatedNewRecords: duplicatedNewRecords_2,
                missingDataUniqueIds: missingDataUniqueIds_1,
                validatingUniqueIds: duplicatedNewRecords_2.length > 0 ? validatingUniqueIds : [],
                replaceAllButton: duplicatedExistingUniqueIds_1.length > 0 || replacedUniqueIds.length > 0,
            }, function () {
                // Trigger onError to process those duplicated new records
                if (onError && duplicatedNewRecords_2.length > 0) {
                    onError(duplicatedNewRecords_2);
                }
            });
            if ((duplicatedExistingUniqueIds_1 && duplicatedExistingUniqueIds_1.length > 0) ||
                (duplicatedUniqueIds_1 && duplicatedUniqueIds_1.length > 0) ||
                (invalidUniqueIds_1 && invalidUniqueIds_1.length > 0) ||
                (missingDataUniqueIds_1 && missingDataUniqueIds_1.length > 0)) {
                this.setState({ hasValidationErrors: true });
            }
            else {
                this.setState({ hasValidationErrors: false });
            }
        }
    };
    EditableTable.prototype.onChange = function (record, event) {
        var index = lodash_1.default.findIndex(this.state.data, { uniqueId: record.uniqueId });
        if (index > -1) {
            this.state.data.splice(index, 1, record);
        }
        this.setState({ data: this.state.data });
    };
    EditableTable.prototype.onUpdate = function (columnKey, record, event) {
        var _this = this;
        var onUpdate = this.props.onUpdate;
        var _a = this.state, data = _a.data, deletedUniqueIds = _a.deletedUniqueIds;
        var index = lodash_1.default.findIndex(data, { uniqueId: record.uniqueId });
        if (index > -1) {
            data.splice(index, 1, record);
        }
        this.setState({ data: data }, function () {
            _this.onValidate(columnKey, {});
            if (onUpdate) {
                onUpdate(data, deletedUniqueIds);
            }
        });
    };
    // Function to delete the new record if all required fields don't have data
    EditableTable.prototype.onDelete = function (record, event) {
        var _this = this;
        if (record.isNew) {
            var onUpdate_2 = this.props.onUpdate;
            var deletedUniqueIds_5 = this.state.deletedUniqueIds;
            var data_3 = this.state.data;
            lodash_1.default.remove(data_3, { uniqueId: record.uniqueId });
            this.setState({ data: data_3 }, function () {
                _this.onValidate('', {});
                if (onUpdate_2) {
                    onUpdate_2(data_3, deletedUniqueIds_5);
                }
            });
        }
    };
    // Function to append the new record to the data list and add the empty row
    EditableTable.prototype.onAppend = function (columnKey, record) {
        var _this = this;
        var onUpdate = this.props.onUpdate;
        var deletedUniqueIds = this.state.deletedUniqueIds;
        record.uniqueId = lodash_1.default.uniqueId();
        record.isNew = true;
        var data = __spreadArray(__spreadArray([], this.state.data, true), [record], false);
        var initData = {};
        Object.keys(record).forEach(function (key) {
            initData[key] = '';
        });
        this.setState({ data: data, initData: initData }, function () {
            _this.onValidate(columnKey, record);
            if (onUpdate) {
                onUpdate(data, deletedUniqueIds);
            }
        });
    };
    // Default props
    EditableTable.defaultProps = {
        deleteAllIcon: true,
    };
    return EditableTable;
}(React.Component));
exports.EditableTable = EditableTable;
